import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Image } from '$components/basic/Image';
import { Input } from '$components/basic/Input';
import Grid from '$components/layout/Grid';
import baseApi from './api';
import { Container, TitleStyled, PrimaryButtonStyled } from './styled';

const { Row, Col } = Grid;

export default class MotReminder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vrm: '',
      vrmIsValid: false,
      vrmError: false,
      vrmUnrecognised: false,
      email: '',
      emailError: false,
      motExpired: false,
      reminderSuccess: false,
      motDueDate: '',
      vehicleId: null,
    };
  }

  setParentState = (data) => this.setState(data);

  render() {
    const {
      vrmIsValid,
      vrmError,
      vrmUnrecognised,
      vrm,
      email,
      emailError,
      motExpired,
      motDueDate,
      reminderSuccess,
      vehicleId,
    } = this.state;

    const { apiKey, consumerApiUrl, source } = this.props;

    const ApiInit = baseApi(apiKey, consumerApiUrl, (data) => this.setParentState(data), 'authkey');
    const api = new ApiInit();
    const { checkVrm, setReminder } = api;

    return (
      <Container>
        {!vrmIsValid && (
          <>
            <Image
              provider="cloudinary"
              src="/icons/icon_mot_t5b5lh.svg"
              alt="MOT Icon"
              layout="fixed"
              width="70"
              height="81"
            />
            <TitleStyled>Find out when your MOT is due</TitleStyled>
            <Input
              name="vrm"
              placeholder="e.g NA11 ABC"
              label="Your registration number"
              floating={vrm.length > 0}
              value={vrm}
              onChange={(e) => this.setState({ vrm: e.target.value })}
              className={classNames('vrm input', vrmError ? 'input-error' : '')}
            />
            {vrmError && <div className="error-input-message">Please enter a correct vrm</div>}
            {vrmUnrecognised && (
              <div className="error-input-message">
                Please check the registration mark you have entered. If you have a cherished plate, it may not
                yet be registered on the DVLA database. Enter the original instead.
              </div>
            )}
          </>
        )}

        {vrmIsValid && !motExpired && !reminderSuccess && (
          <>
            <Image
              provider="cloudinary"
              src="/icons/icon_notification_akcjna.svg"
              alt="Reminder Icon"
              layout="fixed"
              width="70"
              height="81"
            />
            <TitleStyled className="blue">Your MOT is due on {motDueDate}</TitleStyled>
            <p>You will receive a reminder by email before your MOT is due</p>
          </>
        )}

        {motExpired && !reminderSuccess && (
          <>
            <Image
              provider="cloudinary"
              src="/icons/icon_expired_oiekvf.svg"
              alt="Expired Icon"
              layout="fixed"
              width="70"
              height="81"
            />
            <TitleStyled className="red">Your MOT has expired</TitleStyled>
            <p>Get email reminders so you never forget your MOT due date again</p>
          </>
        )}

        {(vrmIsValid || motExpired) && !reminderSuccess && (
          <>
            <Input
              name="email"
              placeholder="Your email address"
              label="Your email address"
              floating={email.length > 0}
              value={email}
              onChange={(e) => this.setState({ email: e.target.value })}
              className={classNames('email input', emailError ? 'input-error' : '')}
            />
            {emailError && <div className="error-input-message">Please enter a correct email</div>}
          </>
        )}

        {reminderSuccess && (
          <>
            <Image
              provider="cloudinary"
              src="/icons/icon_success_hnfliu.svg"
              alt="confirmation"
              layout="fixed"
              width="70"
              height="81"
            />
            <TitleStyled className="green">All set! You’ll never forget your MOT again</TitleStyled>
            You will receive a reminder from us when it’s time to book in your next MOT
          </>
        )}

        <Row>
          <Col span={4} offset={8} xs={{ span: 12, offset: 0 }}>
            {!vrmIsValid && (
              <PrimaryButtonStyled size="large" type="primary" onClick={() => checkVrm(vrm)}>
                Check MOT due date
              </PrimaryButtonStyled>
            )}
            {vrmIsValid && !reminderSuccess && (
              <PrimaryButtonStyled
                size="large"
                type="primary"
                onClick={() => setReminder(email, vehicleId, source, 'mot')}
              >
                Set reminder
              </PrimaryButtonStyled>
            )}
          </Col>
        </Row>
      </Container>
    );
  }
}

MotReminder.propTypes = {
  apiKey: PropTypes.string.isRequired,
  consumerApiUrl: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
};
